import { render, staticRenderFns } from "./EndUserTerms.vue?vue&type=template&id=29f2cf0a&scoped=true&"
import script from "./EndUserTerms.vue?vue&type=script&lang=js&"
export * from "./EndUserTerms.vue?vue&type=script&lang=js&"
import style0 from "./EndUserTerms.vue?vue&type=style&index=0&id=29f2cf0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f2cf0a",
  null
  
)

export default component.exports